import { render, staticRenderFns } from "./HistoricoChat.vue?vue&type=template&id=0c7a285c&scoped=true"
import script from "./HistoricoChat.vue?vue&type=script&lang=js"
export * from "./HistoricoChat.vue?vue&type=script&lang=js"
import style0 from "./HistoricoChat.vue?vue&type=style&index=0&id=0c7a285c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a285c",
  null
  
)

export default component.exports